import IParamServices from "../IParamServices";
import BaseService from "../base/BaseService";
import { IServiceResponse } from "@/core/model/rest/IServiceResponse";
import { IProduct, IProductType } from "@/core/model/sys/IProduct";
import { eProductType } from "@/core/model/GloblasEnum";
import { ITax } from "@/core/model/sys/IEmpresaCSD";

export default class ProductService extends BaseService
{
  constructor(param: IParamServices)
  {
    super(param);
  }
  public NewProduct():IProduct
  {
    return {
      Gid: this.NewId,
      ProductType: this.getProductType()[0],
      Code: '',
      ProductName: '',
      Price: 0,
      FiscalCode:null,
      FiscalUnitCode:null,
      FiscalUnitDescCode:null,
      ObjetoImpCode:null,
      CreatedTime: new Date(),
      ModifiedBy: 0,
      ModifiedTime: new Date(),
      CreatedBy: 0,
      Active: true,
      Deleted: false,
      CreatedByEmployee: null,
      ModifiedByEmployee: null,
      IsNew: true,
      TaxId:null,
      TaxAmount:null,
      Tax:null
    };
  }
  public getProductType():IProductType[]
  {
    return [
      {
        Title:'ProductType.Cargo',
        ProductType: eProductType.Cargo
      },
      {
        Title:'ProductType.Abono',
        ProductType: eProductType.Abono
      },
    ]
  }
  public async ListActiveProducts():Promise<IProduct[]>
  {
    const products = Array<IProduct>();
    const response:IServiceResponse = await this.Get('IndexProduct/ListActiveProducts',null,null,null,true,false,null);  
    if(response.Response)
    {
      const types = this.getProductType();
      for (const element of response.Response)
      {
        const prd: IProduct = {...element};
        const type1 = element.ProductType;
        const aux = types.find((t:IProductType) => t.ProductType === type1);
        if(aux)
        {
          prd.ProductType = aux;
        }
        products.push(prd);  
      }
    }    
    return products;
  }
  public async ListProducts():Promise<IProduct[]>
  {
    const products = Array<IProduct>();
    const response:IServiceResponse = await this.Get('IndexProduct/ListProducts',null,null,null,true,false,null);  
    if(response.Response)
    {
      const types = this.getProductType();
      for (const element of response.Response)
      {
        const prd: IProduct = {...element};
        const type1 = element.ProductType;
        const aux = types.find((t:IProductType) => t.ProductType === type1);
        if(aux)
        {
          prd.ProductType = aux;
        }
        products.push(prd);  
      }
    }    
    return products;
  }   
  public async SaveProduct(product:IProduct):Promise<string>
  {        
    const response:IServiceResponse =  await this.Post('IndexProduct/SaveProduct',product,null,null,null,true,false,null);           
    if(response && response.Response)
    {      
      return response.Response.Result;
    }
    else
      return this.NoResponse;
  } 
  public async GetSATTax():Promise<ITax[]>
  {    
    const response:IServiceResponse =  await this.Get('IndexGeneric/GetSATTax',null,null,null,true,false,null);     
    if(response && response.Response)
    {      
      return response.Response;
    }
    else
      return [];
  } 
}